import React, { Component } from "react";
import { _lp } from "../logic/wording";
import {
  showLoginModal,
  showSingupModal
} from "../redux/actions/account_settings";
import { connect } from "react-redux";
import { store } from "../globals";
import baseLink from "../baseLink";

class _LoginModal extends Component {
  static closeModal() {
    store.dispatch(showLoginModal(false));
  }

  static singup() {
    store.dispatch(showLoginModal(false));
    store.dispatch(showSingupModal(true));
  }

  constructor(props) {
    super(props);
    this.state = {
      mail: "",
      password: "",
      remember: false,
      loggedIn: false,
      formErrors: []
    };
  }

  componentDidMount() {
    if (this.refs.loginmodal) {
      if (this.props.show_login_modal) {
        document.getElementById("login-modal").appendChild(this.refs.loginmodal);
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
    // const a = document.getElementById("login-modal");
    // document.getElementById("login-modal").addEventListener("click", e => {
    //   if (e.target !== a) _LoginModal.closeModal();
    // });
  };

  componentDidUpdate() {
    if (this.refs.loginmodal && !this.props.show_singup_modal) {
      if (this.props.show_login_modal) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  updateMail = val => {
    this.setState({
      mail: val.target.value
    });
  };

  updatePassword = val => {
    this.setState({
      password: val.target.value
    });
  };

  updateRemember = val => {
    this.setState({
      remember: val.target.checked
    });
  };

  login = e => {
    e.preventDefault();
    unraiseError("form");

    const information = {
      email: this.state.mail,
      password: this.state.password,
      remember: this.state.remember
    };

    const init = {
      method: "POST",
      body: JSON.stringify(information)
    };

    const that = this;
    // managing errors
    let err0 = false;
    let err1 = false;
    let err2 = false;

    if (this.state.mail !== "") {
      // Checking email
      let re = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;
      if (!re.test(this.state.mail)) {
        raiseError("mail", 9, _lp("Veuillez saisir une adresse email correcte"));
        err2 = true;
      } else {
        unraiseError("mail");
      }
    } else {
      raiseError("mail", 9, _lp("Veuillez saisir votre adresse mail"));
      err0 = true;
    }

    if (this.state.password === "") {
      raiseError("password", 9, _lp("Veuillez saisir votre mot de passe"));
      err1 = true;
    } else unraiseError("password");

    if (!err0 && !err1 && !err2) {
      fetch(`${baseLink}/data/contracts/login`, init)
        .then(response => {
          response.json()
            .then((j_response) => {
              if (j_response.status === "success") {
                that.setState({
                  loggedIn: true
                });

                _LoginModal.closeModal();

                let cnx = document.getElementById('connexion');
                cnx.innerText = j_response.data.userEmail;
                cnx.setAttribute('href', `${baseLink}/compte`);
                cnx.setAttribute('target', '_blank');
              } else {
                raiseError("form", 9, _lp(j_response.data.errors[0]));
              }
            })
            .catch(jsonError => {
              raiseError("global", 2, _lp("Erreur de connexion au serveur"));
            });
        })
        .catch(error => {
          raiseError("global", 2, _lp("Erreur de connexion au serveur"));
        });
    }
  };

  render() {
    return (
      <div ref="loginmodal">
        {this.props.show_login_modal && (
          <div className="lpm user-modal signin-modal">
            <div className="lpm__container">
              <div className="lpm__header">
                <h3 className="lpm__title">Connexion à votre compte</h3>
                <div
                  className="lpm__close icn-x"
                  onClick={_LoginModal.closeModal}
                />
              </div>
              <div className="lpm__body">
                <div className="user-form">
                  <div className="user-form__body">
                    {this.props.error_form && <div className="alert error">
                      <span className="help-block">
                        {_lp(this.props.error_form.message)}
                    </span></div>}
                    <div
                      className={`form-group ${
                        typeof this.props.error_mail === "undefined"
                          ? ""
                          : " error"
                      }`}
                    >
                      <label htmlFor="lf-email">Adresse email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="lf-email"
                        onChange={this.updateMail}
                      />
                      {typeof this.props.error_mail !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_mail.message)}
                        </span>
                      )}
                    </div>
                    <div
                      className={`form-group ${
                        typeof this.props.error_password === "undefined"
                          ? ""
                          : " error"
                      }`}
                    >
                      <label htmlFor="lf-pass">Mot de passe</label>
                      <input
                        type="password"
                        className="form-control"
                        id="lf-pass"
                        onChange={this.updatePassword}
                      />
                      {typeof this.props.error_password !== "undefined" && (
                        <span className="help-block">
                          {_lp(this.props.error_password.message)}
                        </span>
                      )}
                    </div>
                    {/* if it needs captcha */}
                    {/* <div className="form-group">
                      <label htmlFor="g-recaptcha">
                        Veuillez confirmer que vous n'êtes pas un robot
                      </label>
                      <div
                        id="g-recaptcha"
                        className="g-recaptcha"
                        data-sitekey="6LeD2BwTAAAAAG_kE2QprZMvcn1UtJQdKFp9rUeo"
                      />
                    </div> */}
                    <div className="user-form__actions">
                      <div className="form-group lp-chbx">
                        <input
                          type="checkbox"
                          id="remember-me"
                          className="lpcbx"
                          onChange={this.updateRemember}
                        />
                        <label htmlFor="remember-me">
                          <span className="chbx-txt">Se souvenir de moi</span>
                        </label>
                      </div>
                      <div
                        onClick={this.login}
                        className="btn btn-primary user-cta"
                      >
                        Continuer
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lpm__footer user-form__footer">
                <a id="singup" onClick={_LoginModal.singup} href="#">
                  Inscription
                </a>
                <a href="/compte/recuperer-mdp" target="_blank">
                  Mot de passe oublié ?
                </a>
              </div>
            </div>
          </div>
        )}
        {this.state.loggedIn && (
          <div className="cf-success">
            <div className="success">Vous êtes maintenant connecté</div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  show_login_modal: state.account_settings.show_login_modal,
  show_singup_modal: state.account_settings.show_singup_modal,
  error_mail: state.errors.components["mail"],
  error_password: state.errors.components["password"],
  error_form: state.errors.components["form"]
});

const mapDispatchToProps = dispatch => ({
  closeContact: () => {
    dispatch(showLoginModal(false));
  }
});

export const LoginModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(_LoginModal);



// WEBPACK FOOTER //
// ./src/components/login_modal.js